<template>
    <tab-layout @scroll-bottom="fetchActivity">
        <template #title>
            <!-- {{ $l10n.__('Activité') }} -->
        </template>
        <template #content>
            <div class="overview-content">
                <activity-forms :isSetup="isSetup" :linkedtype="linkedtype" :linkedid="linkedid" />
                <div class="typographies-heading-h2 tab-activity-subtitle">
                    {{ $l10n.__('Historique des activités') }}
                </div>
                <timeline
                    :linkedtype="linkedTypeCheckThirdtype"
                    :linkedid="linkedid"
                    :overviewType="linkedtype"
                    :useFilters="true"
                >
                </timeline>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import ActivityForms from './ActivityForms.vue';
import Timeline from 'vcomponents/timeline/Timeline.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import EmailMixins from 'mixins/EmailMixins';

export default {
    components: {
        Timeline,
        TabLayout,
        ActivityForms,
    },
    mixins: [EmailMixins],
    data() {
        return {
            account: {},
        };
    },
    computed: {
        linkedid() {
            return this.$store.getters.linkedid;
        },
        linkedtype() {
            return this.$store.getters.linkedtype;
        },
        linkedTypeCheckThirdtype() {
            if (this.linkedtype === 'third') {
                return this.$store.getters.identity.type;
            } else {
                return this.linkedtype;
            }
        },
    },
    methods: {
        fetchActivity() {
            EventBus.emit('timeline:fetch-past-log');
        },
    },
};
</script>
<style scoped lang="scss">
.overview-flex-container {
    display: flex;
    gap: var(--spacing-4);
}

.overview-content {
    min-height: 760px;

    &--new {
        flex: 1;
        min-width: 0;
    }
    .tab-activity-subtitle {
        margin-top: var(--spacing-4);
        margin-bottom: var(--spacing-3);
    }
}
</style>
